import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import PropTypes from 'prop-types';
import styles from "./../../SearchWidget.module.scss";
import Checkbox from "../../../Common/Checkbox/Checkbox";
import {connect} from "react-redux";
import {setImagineMode} from "../../../../services/flightCourse/actions";
import Popup from "../../Common/Popup";

class BookFlightOptions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            milesInfoOpen: false
        }
    }

    handleCheckBoxClick = () => {
        const {setImagineMode, imagineMode} = this.props;
        if (!imagineMode) {
            this.setState({milesInfoOpen: true});
        }
        setImagineMode(!imagineMode);
    };

    isNotAirlineOperated = () => {
        const {firstLeg} = this.props;
        const {origin, destination} = firstLeg;

        return (origin && !origin.airlineOperated) || (destination && !destination.airlineOperated);
    };

    render() {
        const {imagineMode, multiCityMode, promoCode, inlineStyles, display, classes, t} = this.props;

        if (!display) {
            return null;
        }

        const {milesInfoOpen} = this.state;
        const isDisabled = !!(multiCityMode || promoCode || this.isNotAirlineOperated());

        const imagineCheckClasses = [styles.imagineCheckbox];
        if (isDisabled) imagineCheckClasses.push(styles.imagineCheckBoxDisabled);

        return (
            <div className={[styles.bookFlightOptionsContainer, classes].join(' ')} style={inlineStyles} id={'search-widget-book-flight-opts'}>
                <span className={imagineCheckClasses.join(' ')} onClick={isDisabled ? () => null : this.handleCheckBoxClick}>
                    <Checkbox checked={imagineMode} disabled={isDisabled}/>&nbsp;{t('Book with SATA IMAGINE miles')}
                </span>
                &nbsp;
                &nbsp;
                <i className={[styles.genericInfoIcon, 'icon-sata-info-icon'].join(' ')}
                   style={isDisabled ? {color: 'rgba(82,198,226,.4)'} : {}}
                   title={t('Only available on flights operated by SATA | Azores Airlines')+'.'}
                   aria-hidden={true}
                   onClick={() => this.setState({milesInfoOpen: true})}>
                    <Popup show={milesInfoOpen} closeHandler={e => {e.stopPropagation();this.setState({milesInfoOpen: false})}}>
                        <span style={{fontFamily: 'NeoSansMedium'}}>{t('Book with SATA IMAGINE miles')}</span>
                        <span style={{fontSize: '1.1em'}}>{t('Only available on flights operated by SATA | Azores Airlines')}.</span>
                    </Popup>
                </i>
            </div>
        );
    }
}

BookFlightOptions.propTypes = {
    classes: PropTypes.string,
    display: PropTypes.bool,
    inlineStyles: PropTypes.object,
    firstLeg: PropTypes.object,
    promoCode: PropTypes.string,
    multiCityMode: PropTypes.bool,
    imagineMode: PropTypes.bool,
    setImagineMode: PropTypes.func,
    t: PropTypes.func,
};

BookFlightOptions.defaultProps = {
    classes: '',
    display: true,
    inlineStyles: {},
    firstLeg: null,
    promoCode: null,
    multiCityMode: false,
    imagineMode: false,
    setImagineMode: () => null,
    t: s => s
};

export default withTranslation()(connect(state => ({
    promoCode: state.flightCourse.promoCode,
    firstLeg: state.flightCourse.legs[0],
    multiCityMode: state.flightCourse.roundTrip === 'MULTI',
    imagineMode: state.flightCourse.imagineMode
}), {setImagineMode})(BookFlightOptions));